import React from "react";
import "./App.css";
import { SpecificRhythm } from "./rhythms/rhythm-types";
import "./composition-info.css";
export interface RhythmPlace {
    rhythm: SpecificRhythm;
    current: number;
}

export interface CompositionInfoProps {
    time: number;
    rhythmPlace: RhythmPlace;
}

function CompositionInfo(props: CompositionInfoProps) {
    const current = props.rhythmPlace.current;
    const soFar = [0];
    props.rhythmPlace.rhythm.bols.forEach((line, i) => {
        soFar.push(line.length + soFar[soFar.length - 1]);
    });
    const bolList = props.rhythmPlace.rhythm.bols.map((line, lineNum) => (
        <>
            <tr>
                {line.map((b, i) => (
                    <>
                        <td
                            className={
                                soFar[lineNum] + i + 1 === current
                                    ? "current"
                                    : ""
                            }
                        >
                            {b}
                        </td>
                    </>
                ))}
            </tr>
        </>
    ));
    const table = (
        <div id="composition-table">
            <table>
                <tbody>
                    <tr>{bolList}</tr>
                </tbody>
            </table>
        </div>
    );
    const info = (
        <>
            <p id="composition-info">
                {props.rhythmPlace.rhythm.displayName} (
                {props.rhythmPlace.rhythm.beatsPerCycle}) beats
            </p>
        </>
    );

    return (
        <div id="composition-container">
            {info}
            <p id="beat-counter">beat {current}</p>
            {table}
        </div>
    );
}

export default CompositionInfo;
